import { token } from '@atlaskit/tokens';
import messages from './messages.tsx';
import type { CategoryColorMeta } from './types.tsx';

export const GREY_LIGHTEST_META: CategoryColorMeta = {
	name: 'GREY_LIGHTEST',
	backgroundColor: token('color.background.neutral'),
	textColor: token('color.text.accent.gray.bolder'),
	messageLabel: messages.greyLightest,
};

const GREY_LIGHTER_META: CategoryColorMeta = {
	name: 'GREY_LIGHTER',
	backgroundColor: token('color.background.neutral.hovered'),
	textColor: token('color.text.accent.gray.bolder'),
	messageLabel: messages.greyLighter,
};

const GREY_META: CategoryColorMeta = {
	name: 'GREY',
	backgroundColor: token('color.background.neutral.pressed'),
	textColor: token('color.text.accent.gray.bolder'),
	messageLabel: messages.grey,
};

const GREY_DARKER_META: CategoryColorMeta = {
	name: 'GREY_DARKER',
	backgroundColor: token('color.background.neutral.bold'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.greyDarker,
};

const GREY_DARKEST_META: CategoryColorMeta = {
	name: 'GREY_DARKEST',
	backgroundColor: token('color.background.neutral.bold.pressed'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.greyDarkest,
};

const PURPLE_LIGHTEST_META: CategoryColorMeta = {
	name: 'PURPLE_LIGHTEST',
	backgroundColor: token('color.background.accent.purple.subtlest'),
	textColor: token('color.text.accent.purple.bolder'),
	messageLabel: messages.purpleLightest,
};

const PURPLE_LIGHTER_META: CategoryColorMeta = {
	name: 'PURPLE_LIGHTER',
	backgroundColor: token('color.background.accent.purple.subtler'),
	textColor: token('color.text.accent.purple.bolder'),
	messageLabel: messages.purpleLighter,
};

const PURPLE_META: CategoryColorMeta = {
	name: 'PURPLE',
	backgroundColor: token('color.background.accent.purple.subtle'),
	textColor: token('color.text.accent.purple.bolder'),
	messageLabel: messages.purple,
};

const PURPLE_DARKER_META: CategoryColorMeta = {
	name: 'PURPLE_DARKER',
	backgroundColor: token('color.text.accent.purple'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.purpleDarker,
};

const PURPLE_DARKEST_META: CategoryColorMeta = {
	name: 'PURPLE_DARKEST',
	backgroundColor: token('color.text.accent.purple.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.purpleDarkest,
};

const BLUE_LIGHTEST_META: CategoryColorMeta = {
	name: 'BLUE_LIGHTEST',
	backgroundColor: token('color.background.accent.blue.subtlest'),
	textColor: token('color.text.accent.blue.bolder'),
	messageLabel: messages.blueLightest,
};

const BLUE_LIGHTER_META: CategoryColorMeta = {
	name: 'BLUE_LIGHTER',
	backgroundColor: token('color.background.accent.blue.subtler'),
	textColor: token('color.text.accent.blue.bolder'),
	messageLabel: messages.blueLighter,
};

const BLUE_META: CategoryColorMeta = {
	name: 'BLUE',
	backgroundColor: token('color.background.accent.blue.subtle'),
	textColor: token('color.text.accent.blue.bolder'),
	messageLabel: messages.blue,
};

const BLUE_DARKER_META: CategoryColorMeta = {
	name: 'BLUE_DARKER',
	backgroundColor: token('color.text.accent.blue'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.blueDarker,
};

const BLUE_DARKEST_META: CategoryColorMeta = {
	name: 'BLUE_DARKEST',
	backgroundColor: token('color.text.accent.blue.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.blueDarkest,
};

const TEAL_LIGHTEST_META: CategoryColorMeta = {
	name: 'TEAL_LIGHTEST',
	backgroundColor: token('color.background.accent.teal.subtlest'),
	textColor: token('color.text.accent.teal.bolder'),
	messageLabel: messages.tealLightest,
};

const TEAL_LIGHTER_META: CategoryColorMeta = {
	name: 'TEAL_LIGHTER',
	backgroundColor: token('color.background.accent.teal.subtler'),
	textColor: token('color.text.accent.teal.bolder'),
	messageLabel: messages.tealLighter,
};

const TEAL_META: CategoryColorMeta = {
	name: 'TEAL',
	backgroundColor: token('color.background.accent.teal.subtle'),
	textColor: token('color.text.accent.teal.bolder'),
	messageLabel: messages.teal,
};

const TEAL_DARKER_META: CategoryColorMeta = {
	name: 'TEAL_DARKER',
	backgroundColor: token('color.text.accent.teal'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.tealDarker,
};

const TEAL_DARKEST_META: CategoryColorMeta = {
	name: 'TEAL_DARKEST',
	backgroundColor: token('color.text.accent.teal.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.tealDarkest,
};

const GREEN_LIGHTEST_META: CategoryColorMeta = {
	name: 'GREEN_LIGHTEST',
	backgroundColor: token('color.background.accent.green.subtlest'),
	textColor: token('color.text.accent.green.bolder'),
	messageLabel: messages.greenLightest,
};

const GREEN_LIGHTER_META: CategoryColorMeta = {
	name: 'GREEN_LIGHTER',
	backgroundColor: token('color.background.accent.green.subtler'),
	textColor: token('color.text.accent.green.bolder'),
	messageLabel: messages.greenLighter,
};

const GREEN_META: CategoryColorMeta = {
	name: 'GREEN',
	backgroundColor: token('color.background.accent.green.subtle'),
	textColor: token('color.text.accent.green.bolder'),
	messageLabel: messages.green,
};

const GREEN_DARKER_META: CategoryColorMeta = {
	name: 'GREEN_DARKER',
	backgroundColor: token('color.background.accent.green.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.greenDarker,
};

const GREEN_DARKEST_META: CategoryColorMeta = {
	name: 'GREEN_DARKEST',
	backgroundColor: token('color.text.accent.green.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.greenDarkest,
};

const LIME_LIGHTEST_META: CategoryColorMeta = {
	name: 'LIME_LIGHTEST',
	backgroundColor: token('color.background.accent.lime.subtlest'),
	textColor: token('color.text.accent.lime.bolder'),
	messageLabel: messages.limeLightest,
};

const LIME_LIGHTER_META: CategoryColorMeta = {
	name: 'LIME_LIGHTER',
	backgroundColor: token('color.background.accent.lime.subtler'),
	textColor: token('color.text.accent.lime.bolder'),
	messageLabel: messages.limeLighter,
};

const LIME_META: CategoryColorMeta = {
	name: 'LIME',
	backgroundColor: token('color.background.accent.lime.subtle'),
	textColor: token('color.text.accent.lime.bolder'),
	messageLabel: messages.lime,
};

const LIME_DARKER_META: CategoryColorMeta = {
	name: 'LIME_DARKER',
	backgroundColor: token('color.text.accent.lime'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.limeDarker,
};

const LIME_DARKEST_META: CategoryColorMeta = {
	name: 'LIME_DARKEST',
	backgroundColor: token('color.text.accent.lime.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.limeDarkest,
};

const YELLOW_LIGHTEST_META: CategoryColorMeta = {
	name: 'YELLOW_LIGHTEST',
	backgroundColor: token('color.background.accent.yellow.subtlest'),
	textColor: token('color.text.accent.yellow.bolder'),
	messageLabel: messages.yellowLightest,
};

const YELLOW_LIGHTER_META: CategoryColorMeta = {
	name: 'YELLOW_LIGHTER',
	backgroundColor: token('color.background.accent.yellow.subtler'),
	textColor: token('color.text.accent.yellow.bolder'),
	messageLabel: messages.yellowLighter,
};

const YELLOW_META: CategoryColorMeta = {
	name: 'YELLOW',
	backgroundColor: token('color.background.accent.yellow.subtle'),
	textColor: token('color.text.accent.yellow.bolder'),
	messageLabel: messages.yellow,
};

const YELLOW_DARKER_META: CategoryColorMeta = {
	name: 'YELLOW_DARKER',
	backgroundColor: token('color.text.accent.yellow'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.yellowDarker,
};

const YELLOW_DARKEST_META: CategoryColorMeta = {
	name: 'YELLOW_DARKEST',
	backgroundColor: token('color.text.accent.yellow.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.yellowDarkest,
};

const ORANGE_LIGHTEST_META: CategoryColorMeta = {
	name: 'ORANGE_LIGHTEST',
	backgroundColor: token('color.background.accent.orange.subtlest'),
	textColor: token('color.text.accent.orange.bolder'),
	messageLabel: messages.orangeLightest,
};

const ORANGE_LIGHTER_META: CategoryColorMeta = {
	name: 'ORANGE_LIGHTER',
	backgroundColor: token('color.background.accent.orange.subtler'),
	textColor: token('color.text.accent.orange.bolder'),
	messageLabel: messages.orangeLighter,
};

const ORANGE_META: CategoryColorMeta = {
	name: 'ORANGE',
	backgroundColor: token('color.background.accent.orange.subtle'),
	textColor: token('color.text.accent.orange.bolder'),
	messageLabel: messages.orange,
};

const ORANGE_DARKER_META: CategoryColorMeta = {
	name: 'ORANGE_DARKER',
	backgroundColor: token('color.background.accent.orange.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.orangeDarker,
};

const ORANGE_DARKEST_META: CategoryColorMeta = {
	name: 'ORANGE_DARKEST',
	backgroundColor: token('color.text.accent.orange.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.orangeDarkest,
};

const RED_LIGHTEST_META: CategoryColorMeta = {
	name: 'RED_LIGHTEST',
	backgroundColor: token('color.background.accent.red.subtlest'),
	textColor: token('color.text.accent.red.bolder'),
	messageLabel: messages.redLightest,
};

const RED_LIGHTER_META: CategoryColorMeta = {
	name: 'RED_LIGHTER',
	backgroundColor: token('color.background.accent.red.subtler'),
	textColor: token('color.text.accent.red.bolder'),
	messageLabel: messages.redLighter,
};

const RED_META: CategoryColorMeta = {
	name: 'RED',
	backgroundColor: token('color.background.accent.red.subtle'),
	textColor: token('color.text.accent.red.bolder'),
	messageLabel: messages.red,
};

const RED_DARKER_META: CategoryColorMeta = {
	name: 'RED_DARKER',
	backgroundColor: token('color.background.accent.red.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.redDarker,
};

const RED_DARKEST_META: CategoryColorMeta = {
	name: 'RED_DARKEST',
	backgroundColor: token('color.text.accent.red.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.redDarkest,
};

const MAGENTA_LIGHTEST_META: CategoryColorMeta = {
	name: 'MAGENTA_LIGHTEST',
	backgroundColor: token('color.background.accent.magenta.subtlest'),
	textColor: token('color.text.accent.magenta.bolder'),
	messageLabel: messages.magentaLightest,
};

const MAGENTA_LIGHTER_META: CategoryColorMeta = {
	name: 'MAGENTA_LIGHTER',
	backgroundColor: token('color.background.accent.magenta.subtler'),
	textColor: token('color.text.accent.magenta.bolder'),
	messageLabel: messages.magentaLighter,
};

const MAGENTA_META: CategoryColorMeta = {
	name: 'MAGENTA',
	backgroundColor: token('color.background.accent.magenta.subtle.hovered'),
	textColor: token('color.text.accent.magenta.bolder'),
	messageLabel: messages.magenta,
};

const MAGENTA_DARKER_META: CategoryColorMeta = {
	name: 'MAGENTA_DARKER',
	backgroundColor: token('color.text.accent.magenta'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.magentaDarker,
};

const MAGENTA_DARKEST_META: CategoryColorMeta = {
	name: 'MAGENTA_DARKEST',
	backgroundColor: token('color.text.accent.magenta.bolder'),
	textColor: token('color.text.inverse'),
	messageLabel: messages.magentaDarkest,
};

export const CHECK_MARK_COLOR_DARK = token('color.text.inverse');
export const CHECK_MARK_COLOR_LIGHT = token('color.text');

export const CATEGORY_THEMES: CategoryColorMeta[] = [
	GREY_LIGHTEST_META,
	PURPLE_LIGHTEST_META,
	BLUE_LIGHTEST_META,
	TEAL_LIGHTEST_META,
	GREEN_LIGHTEST_META,
	LIME_LIGHTEST_META,
	YELLOW_LIGHTEST_META,
	ORANGE_LIGHTEST_META,
	RED_LIGHTEST_META,
	MAGENTA_LIGHTEST_META,
	GREY_LIGHTER_META,
	PURPLE_LIGHTER_META,
	BLUE_LIGHTER_META,
	TEAL_LIGHTER_META,
	GREEN_LIGHTER_META,
	LIME_LIGHTER_META,
	YELLOW_LIGHTER_META,
	ORANGE_LIGHTER_META,
	RED_LIGHTER_META,
	MAGENTA_LIGHTER_META,
	GREY_META,
	PURPLE_META,
	BLUE_META,
	TEAL_META,
	GREEN_META,
	LIME_META,
	YELLOW_META,
	ORANGE_META,
	RED_META,
	MAGENTA_META,
	GREY_DARKER_META,
	PURPLE_DARKER_META,
	BLUE_DARKER_META,
	TEAL_DARKER_META,
	GREEN_DARKER_META,
	LIME_DARKER_META,
	YELLOW_DARKER_META,
	ORANGE_DARKER_META,
	RED_DARKER_META,
	MAGENTA_DARKER_META,
	GREY_DARKEST_META,
	PURPLE_DARKEST_META,
	BLUE_DARKEST_META,
	TEAL_DARKEST_META,
	GREEN_DARKEST_META,
	LIME_DARKEST_META,
	YELLOW_DARKEST_META,
	ORANGE_DARKEST_META,
	RED_DARKEST_META,
	MAGENTA_DARKEST_META,
];
